const timer = setInterval(() => {
  const targetItems = document.querySelectorAll('.cd-rewards-container');
  if (Shopify && Shopify.country !== 'SG') {
    targetItems.forEach(item => {
      item.style.display = 'none';
    });
  } else {
    targetItems.forEach(item => {
      item.style.display = '';
    });
  }
}, 1000);
